var path = 'src/app/ui/page-wrapper.html';
var html = "<div class=content> <div notifications></div> <div class=content-inner ng-transclude></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/ui/page-wrapper.html
 ** module id = 687
 ** module chunks = 0
 **/